import { IRecommendTemplate } from '@/services/textDetail';
import { Checkbox } from '@ai-indeed/idp-ui';
import { FC } from 'react';
import styles from './index.less';

interface IProps {
  className?: string;
  data: IRecommendTemplate[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export const TemplateArea: FC<IProps> = (props) => {
  const { className, onChange, data = [], selectedIds } = props;

  // const inputRef = useRef<HTMLInputElement>(null);
  // const [isSearch, setIsSearch] = useState(false);

  // const getReconmanndTemplates = () => {
  //   getRecommendTemplate('').then((res) => {
  //     if (res.code !== 0) {
  //       message.error(res.msg);
  //     }
  //   });
  // };

  // const handleSearch = (keyword: string) => {
  //   getTemplates({
  //     fuz_template_name: keyword,
  //     page: 1,
  //     size: 1000,
  //     is_pdf_based: true,
  //     is_image_based: false,
  //   }).then((res) => {
  //     if (res.code !== 0) {
  //       message.error(res.msg);
  //       return;
  //     }
  //     console.log('records__', res.data.records);
  //     setTemplateList(res.data.records);
  //   });
  // };

  const onCheckTemplate = (checked: boolean, id: string) => {
    let list = [...selectedIds];
    if (checked) {
      list.push(id);
    } else {
      list = list.filter((item) => item !== id);
    }
    onChange(list);
  };

  // const toggleIsSearch = () => {
  //   if (isSearch) {
  //     setIsSearch(false);
  //     getReconmanndTemplates();
  //   } else {
  //     flushSync(() => {
  //       setIsSearch(true);
  //     });
  //     inputRef.current?.focus();
  //   }
  // };

  return (
    <div className={className}>
      <div className={styles['ta-head']}>
        <span>上传后执行（选填）</span>
        {/* {!isSearch ? (
          <IconFont
            onClick={toggleIsSearch}
            type="icon-sousuo"
            className="cursor-pointer"
          ></IconFont>
        ) : (
          <Input
            ref={inputRef}
            placeholder="搜索"
            width={220}
            onBlur={toggleIsSearch}
            className={styles['ta-search__input']}
            prefix={
              <IconFont
                type="icon-sousuo"
                className="text-sm text-[#8b8f97]"
              ></IconFont>
            }
          />
        )} */}
      </div>
      <div className={styles['ta-content']}>
        {data.map((item) => (
          <Checkbox
            key={item.template_code}
            checked={selectedIds.includes(item.template_code)}
            onChange={(e) =>
              onCheckTemplate(e.target.checked, item.template_code)
            }
          >
            {item.template_name}
          </Checkbox>
        ))}
      </div>
    </div>
  );
};
